import filter from './filter.js';

// Trim out all falsy values from an array.
export default function compact(array) {
  return filter(array, Boolean);
}



//////////////////
// WEBPACK FOOTER
// ./~/backbone/~/underscore/modules/compact.js
// module id = 472
// module chunks = 8